function parseValidationErrors(error) {
  return error.message.reduce((acc, err) => {
    const fieldName = err.split(' ')[0].toLowerCase();
    return { ...acc, [fieldName]: err };
  }, {});
}

export default function parseServerError(error) {
  if (error.isValidationError()) {
    return parseValidationErrors(error);
  }

  return { common: error.message };
}



// WEBPACK FOOTER //
// ./src/api/helpers/parseServerError.js